
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral",
      function () {
        return require("private-next-pages/referral/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral"])
      });
    }
  